var noCase = require('no-case')

/**
 * Param case a string.
 *
 * @param  {string} value
 * @param  {string} [locale]
 * @return {string}
 */
module.exports = function (value, locale) {
  return noCase(value, locale, '-')
}



//////////////////
// WEBPACK FOOTER
// ./~/param-case/param-case.js
// module id = 321
// module chunks = 0